import { Sparkles, LayoutGrid, BarChart3, Bell, Newspaper, TrendingUp, AlertTriangle, Trophy, FileText, Users } from 'lucide-react';
import { PageOnboardingTooltip, type OnboardingSlide } from '@/components/onboarding/PageOnboardingTooltip';

const slides: OnboardingSlide[] = [
  {
    icon: Sparkles,
    secondaryIcons: [Newspaper, TrendingUp],
    title: 'Welcome to Signal Intelligence',
    description: "Your real-time command center for news monitoring and AI-powered sentiment analysis — tracking what's being said about you and your partners across the media landscape.",
    gradient: 'from-primary/20 to-primary/5',
  },
  {
    icon: LayoutGrid,
    secondaryIcons: [Users, FileText],
    title: 'Tabs: All, Personal & Partnerships',
    description: '"All" shows combined coverage across everyone. "Personal" filters to only your mentions. "Partnerships" lets you drill into specific deal partners to see their media footprint.',
    gradient: 'from-blue-500/20 to-blue-500/5',
  },
  {
    icon: BarChart3,
    secondaryIcons: [TrendingUp],
    title: 'Sentiment Analysis',
    description: 'Every article is scored as positive, neutral, or negative using AI. The sentiment breakdown gives you an overall positivity percentage so you can spot trends at a glance.',
    gradient: 'from-emerald-500/20 to-emerald-500/5',
  },
  {
    icon: Bell,
    secondaryIcons: [AlertTriangle, Trophy],
    title: 'Priority Alerts & Coverage',
    description: 'Get flagged on high-impact events — injuries, controversies, contract news, and achievements. The coverage feed links directly to source articles so you never miss a beat.',
    gradient: 'from-amber-500/20 to-amber-500/5',
  },
];

export const SignalOnboardingTooltip = () => {
  return (
    <PageOnboardingTooltip
      storageKey="signal_tooltip_dismissed"
      slides={slides}
      dialogTitle="Signal Intelligence Walkthrough"
    />
  );
};
